<div *ngIf="(this.clauses === undefined || this.clauses === null || this.clauses?.length === 0) && !proposalSummary">
    <app-header-title title="Cláusulas e Condições Opcionais"
        subTitle="Não há nenhuma cláusula ou condição opcional cadastrada para inclusão nesta proposta."
        classTitle="title__semibold__orange">
    </app-header-title>
    <section class="clauses__section"></section>
    <hr>
</div>

<div *ngIf="this.clauses !== undefined && this.clauses?.length > 0">
    <!-- <ng-container *ngIf="proposalSummary">
        <app-header-title title="Cláusulas" subTitle="" classTitle="title__semibold__gray">
        </app-header-title>
    </ng-container> -->
    <ng-container *ngIf="!proposalSummary">
        <app-header-title title="Cláusulas e Condições Opcionais"
            subTitle="Selecione as cláusulas que serão vinculadas à proposta." classTitle="title__semibold__orange">
        </app-header-title>
    </ng-container>

    <section class="clauses__section">
        <mat-expansion-panel *ngFor="let item of clauses;" style="margin: 5px 0px 5px 0px !important;">
            <mat-expansion-panel-header>
                <mat-checkbox [disabled]="onlyRead" [checked]="item.checked" (click)="$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()" (change)="checkedItem($event, item.id)">
                  <strong> {{item.nomeClauseType}} - </strong>
                    {{item.name}}
                </mat-checkbox>
            </mat-expansion-panel-header>
            <div style="width: 100% !important; word-break: break-word !important;">
                <p>{{ item.showTextPart ? (item.text | slice:0:3500) : item.text }}</p>
            </div>
            <hr>
            <div class="div-content-center">
                <button mat-button class="button" (click)="showAllText(item)"
                    *ngIf="item.text?.length > 3500">{{item.showTextPartDesc | uppercase
                    }}</button>
            </div>
            <div *ngIf="item.nomeClauseRatificacao != null">
                <mat-expansion-panel style="margin: 5px 0px 5px 0px !important;">
                    <mat-expansion-panel-header>
                        <mat-checkbox [disabled]="true" [checked]="item.checked" (click)="$event.stopPropagation()"
                            (keydown)="$event.stopPropagation()" (change)="checkedItem($event, item.id)">
                            {{item.nomeClauseRatificacao}}
                        </mat-checkbox>
                    </mat-expansion-panel-header>
                    <div style="width: 100% !important; word-break: break-word !important;">
                        <p>{{ item.textClauseRatificacao ? (item.textClauseRatificacao | slice:0:3500) : item.textClauseRatificacao }}</p>
                    </div>
                    <hr>
                    <div class="div-content-center">
                        <button mat-button class="button" (click)="showAllText(item.textClauseRatificacao)"
                            *ngIf="item.textClauseRatificacao?.length > 3500">{{item.textClauseRatificacao | uppercase
                            }}</button>
                    </div>
                </mat-expansion-panel>
            </div>  
        </mat-expansion-panel>
    </section>
    <hr>
</div>